// Références DOM centralisées — source unique pour tous les modules ui/*.

export const form = document.getElementById('pv-form');
export const sourceSelect = document.getElementById('source');
export const pvwattsKeyWrapper = document.getElementById('pvwatts-key-wrapper');
export const pvwattsKeyInput = document.getElementById('pvwattsKey');
export const geoBtn = document.getElementById('geo-btn');
export const estimateBtn = document.getElementById('estimate-btn');
export const statusEl = document.getElementById('status');
export const statusTextEl = document.getElementById('statusText');
export const statsEl = document.getElementById('stats');
export const dailyProfileChartCanvas = document.getElementById('dailyProfileChart');
export const monthlyProfileChartCanvas = document.getElementById('monthlyProfileChart');
export const monthSelect = document.getElementById('monthSelect');
export const prevDayBtn = document.getElementById('prevDay');
export const nextDayBtn = document.getElementById('nextDay');
export const daySlider = document.getElementById('daySlider');
export const dayLabel = document.getElementById('dayLabel');
export const latInput = document.getElementById('lat');
export const lonInput = document.getElementById('lon');
export const tiltInput = document.getElementById('tilt');
export const lossesInput = document.getElementById('losses');
export const azimuthInput = document.getElementById('azimuth');
export const compareAzimuthCheckbox = document.getElementById('compareAzimuth');
export const azimuth2Wrapper = document.getElementById('azimuth2-wrapper');
export const azimuth2Input = document.getElementById('azimuth2');
export const mapHintEl = document.getElementById('mapHint');
export const mapContainer = document.getElementById('map');
export const exportPdfBtn = document.getElementById('exportPdfBtn');
export const loadingOverlay = document.getElementById('loadingOverlay');
export const sidebarToggle = document.getElementById('sidebar-toggle');
export const sidebarEl = document.getElementById('sidebar');
export const sidebarOverlay = document.getElementById('sidebarOverlay');
export const peakShavingSection = document.getElementById('peakShavingSection');
export const peakShavingStatsEl = document.getElementById('peakShavingStats');
export const peakShavingChartCanvas = document.getElementById('peakShavingChart');
export const optimizeWcBtn = document.getElementById('optimizeWcBtn');
export const optimizeWcResultEl = document.getElementById('optimizeWcResult');
export const peakPowerInputEl = document.getElementById('peakPower');
export const consumptionPowerInputEl = document.getElementById('consumptionPower');
export const wcSplitWrapper = document.getElementById('wc-split-wrapper');
export const peakPower1InputEl = document.getElementById('peakPower1');
export const peakPower2InputEl = document.getElementById('peakPower2');
export const wcSplitHintEl = document.getElementById('wcSplitHint');
export const resultsArea = document.getElementById('resultsArea');
export const exportArea = document.getElementById('exportArea');
